import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../contexts/CartContext';
import { ErrorModal } from '../components/ErrorModal';
export const SoftPlayPackages = () => {
  const {
    addToCart,
    upgradeToGigantatot
  } = useCart();
  const navigate = useNavigate();
  const [addedItems, setAddedItems] = useState<Set<string>>(new Set());
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [showUpgradeOption, setShowUpgradeOption] = useState(false);
  const handleAddToCart = (pkg: (typeof packages)[0]) => {
    const result = addToCart({
      type: 'softplay',
      packageName: pkg.name,
      packageValue: pkg.packageValue,
      price: pkg.price
    });
    if (result.success) {
      // Show success feedback briefly, then redirect to cart
      setAddedItems(prev => new Set(prev).add(pkg.packageValue));
      setErrorMessage('');
      setShowUpgradeOption(false);
      // Redirect to cart after 800ms
      setTimeout(() => {
        navigate('/cart');
        window.scrollTo(0, 0);
      }, 800);
    } else {
      // Show error modal (no scroll)
      setErrorMessage(result.message || 'Unable to add item to cart');
      setShowUpgradeOption(result.showUpgradeOption || false);
    }
  };
  const handleUpgrade = () => {
    upgradeToGigantatot();
    setAddedItems(prev => new Set(prev).add('gigantatot'));
    // Redirect to cart after upgrade
    setTimeout(() => {
      navigate('/cart');
      window.scrollTo(0, 0);
    }, 800);
  };
  const packages = [{
    id: '01',
    name: 'Tiny Tot',
    packageValue: 'tiny-tot',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4WktozD23sUFeswQq2cCuq/77BCF6CB-EA89-44A4-BDDF-18A46698D723-1024x768.jpg',
    features: ['Medium Bounce House', 'Colorful Puzzle Mats (12ft x 10ft)', '3 Bouncy Animals', 'Ball Pit, Slide & Multi-colored balls', 'Jumbo Connect-Four', 'Gym Climbing Blocks', 'Crawling Tunnel', 'Safety Gate'],
    price: '$350'
  }, {
    id: '02',
    name: 'Mega Tot',
    packageValue: 'mega-tot',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bj3F22sb2nuKqenpirTHh1/IMG_4577-1024x768.jpg',
    features: ['Combo Bounce House w/ ball pit', 'Colorful Puzzle Mats (16ft x 14ft)', '4 Bouncy Animals', 'Ball Pit, Slide & Multi-colored balls', 'Jumbo Connect-Four', 'Gym Climbing Blocks', 'Caterpillar Crawling Tunnel', 'Safety Gates', 'Rocking Horse', '"My First Roller Coaster"'],
    price: '$425'
  }, {
    id: '03',
    name: 'Gigantatot',
    packageValue: 'gigantatot',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/71zAVFXd9bzmKmHYJ4QCA8/image.png',
    features: ['Combo Bounce House w/ ball pit', 'Colorful Puzzle Mats (18ft x 16ft)', 'Medium Bounce House w/ Slide', '6 Bouncy Animals', 'Ball Pit, Slide & Multi-colored balls', 'Jumbo Connect-Four', 'Gym Climbing Blocks', 'Caterpillar Crawling Tunnel', 'Safety Gates', 'Rocking Horse', '"My First Roller Coaster"'],
    price: '$500',
    originalPrice: '$525'
  }];
  return <>
      <ErrorModal isOpen={!!errorMessage} message={errorMessage} onClose={() => {
      setErrorMessage('');
      setShowUpgradeOption(false);
    }} showUpgradeOption={showUpgradeOption} onUpgrade={handleUpgrade} data-id="element-944" />

      <div className="bg-white w-full" data-id="element-945">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-946">
          {/* Page Title Section */}
          <div className="text-center mb-16" data-id="element-947">
            <h1 className="text-4xl md:text-5xl font-bold text-primary-500 leading-tight" data-id="element-948">
              Colorful Soft Play Packages
            </h1>
            <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-949">
              Vibrant and engaging play areas perfect for active toddlers.
            </p>
          </div>

          {/* Package Cards Section */}
          <div className="space-y-8" data-id="element-950">
            {packages.map(pkg => <div key={pkg.id} className="bg-white rounded-3xl shadow-lg overflow-hidden border border-gray-100" data-id="element-951">
                <div className="flex flex-col md:flex-row" data-id="element-952">
                  {/* Package Image */}
                  <div className="md:w-1/2 relative" data-id="element-953">
                    <img src={pkg.image} alt={`${pkg.name} Package`} className="w-full h-full object-cover" data-id="element-954" />
                  </div>
                  {/* Package Details */}
                  <div className="p-8 md:w-1/2" data-id="element-955">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-956">
                      <span className="text-primary-500" data-id="element-957">{pkg.id}</span> -{' '}
                      {pkg.name}
                    </h2>
                    <ul className="space-y-3 mb-8" data-id="element-958">
                      {pkg.features.map((feature, idx) => <li key={idx} className="flex items-start" data-id="element-959">
                          <CheckIcon className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-960" />
                          <span data-id="element-961">{feature}</span>
                        </li>)}
                    </ul>
                    <div className="mt-auto text-center border-t border-gray-100 pt-6" data-id="element-962">
                      {pkg.originalPrice ? <>
                          <div className="inline-flex items-center justify-center px-3 py-1 mb-3 bg-red-100 text-red-700 text-xs font-bold uppercase tracking-wide rounded-full" data-id="element-963">
                            ✨ Limited Time Deal
                          </div>
                          <div className="flex items-baseline justify-center gap-3 mb-4" data-id="element-964">
                            <span className="text-2xl font-medium text-gray-400 line-through" data-id="element-965">
                              {pkg.originalPrice}
                            </span>
                            <span className="text-4xl font-bold text-green-800" data-id="element-966">
                              {pkg.price}
                            </span>
                          </div>
                        </> : <span className="text-4xl font-bold text-green-800 block mb-4" data-id="element-967">
                          {pkg.price}
                        </span>}
                      <button onClick={() => handleAddToCart(pkg)} className={`inline-flex items-center px-6 py-3 rounded-md font-medium transition-all shadow-md ${addedItems.has(pkg.packageValue) ? 'bg-green-500 text-white' : 'bg-secondary-500 text-white hover:bg-secondary-600'}`} data-id="element-968">
                        {addedItems.has(pkg.packageValue) ? '✓ Added to Cart' : 'Add to Cart'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </>;
};